import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';

type PositionProp = 'left' | 'right';


export default /*#__PURE__*/_defineComponent({
  __name: 'IconSwitch',
  props: {
    leftIcon: null,
    rightIcon: null,
    leftIconPack: null,
    rightIconPack: null,
    initialPosition: null,
    iconPack: null
  },
  emits: ["switch-image"],
  setup(__props: any, { emit }: { emit: ((e: 'switch-image', value: boolean) => void), expose: any, slots: any, attrs: any }) {

const props = __props as {
  leftIcon: string;
  rightIcon: string;
  leftIconPack?: string;
  rightIconPack?: string;
  initialPosition?: PositionProp;
  iconPack?: string;
};





const value = ref(props.initialPosition === 'right');

function onClick(event: any): void {
  value.value = event.target.checked;
  emit('switch-image', value.value);
}

const rightIconPackOrDefault = computed(() => {
  return props.rightIconPack || props.iconPack || 'mdi';
});

const leftIconPackOrDefault = computed(() => {
  return props.leftIconPack || props.iconPack || 'mdi';
});

return { __sfc: true,props, emit, value, onClick, rightIconPackOrDefault, leftIconPackOrDefault }
}

})